import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { hasAnalyticsConsent, subscribeToConsent, trackPageView } from './ga4';

export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // Track the initial route and every React Router navigation.
    if (hasAnalyticsConsent()) trackPageView(location);
  }, [location]);

  useEffect(
    () =>
      subscribeToConsent((allowed) => {
        // If consent is granted on the preferences page, track the current route immediately.
        if (allowed) trackPageView(location);
      }),
    [location]
  );

  return null;
}
